import Vue from 'vue';
import { getApp } from './utils/util';

export default {
  idDev: true,
  cgi: {
    submitHost: 'https://reviewapi.gameplus.qq.com/',
    host: 'https://api.gameplus.qq.com/',
    testHost: 'https://ams-pre.xinyue.qq.com/',
    devHost: 'http://devapi.gameplus.qq.com/',
    amsHost: 'https://mp.game.qq.com/external/aci/main',
    pressureHost: 'http://ycapi.gameplus.qq.com/',
  },
  web: {
    host: 'https://m.gameplus.qq.com/',
    testHost: 'https://mtest.gameplus.qq.com/',
  },
  netEnvironment: {
    formal: 0,
    test: 2,
    dev: 3,
    pressureHost: 6, // 压测环境
  },
  qqAppId: '',
  wxAppId: '',
  pageUrl: {
    groupDetail: 'tgc://native?moduleName=groupdetail',
    groupmanagerlist: 'tgc://native?moduleName=groupmanagerlist',
    blackHouse: 'tgc://native?moduleName=blackHouse',
    addfriends: 'tgc://native?moduleName=addfriends',
    personal: 'tgc://native?moduleName=personal',
    taskCenter: 'tgc://native?moduleName=taskCenter',
    myFollow: 'tgc://native?moduleName=myFollow',
    collection: 'tgc://native?moduleName=collection',
    browsingHistory: 'tgc://native?moduleName=browsingHistory',
    home: 'tgc://index?tabName=home',
    profile: 'tgc://profile',
    setting: 'tgc://setting',
    group: 'tgc://index?tabName=group',
    follow: 'tgc://index?tabName=follow',
    mine: 'tgc://index?tabName=mine',
    homecalendar: 'tgc://native?moduleName=homecalendar',
    homerevelation: 'tgc://native?moduleName=homerevelation',
    homegroupvip: 'tgc://native?moduleName=homegroupvip',
    pointsdetail: 'tgc://native?moduleName=pointsdetail',
    homediscuss: 'tgc://native?moduleName=homediscuss',
    globalsearch: 'tgc://native?moduleName=globalsearch',
    userlist: 'tgc://native?moduleName=userlist',
    // eslint-disable-next-line no-template-curly-in-string
    groupdetailShare: 'hi-direct/pages/group_detail.html?groupId=${groupId}&_static=1',
    // eslint-disable-next-line no-template-curly-in-string
    topicShare: 'hi-direct/pages/topic.html?topicId=${topicId}&_static=1',
    // eslint-disable-next-line no-template-curly-in-string
    personalShare: 'hi-direct/pages/person.html?uid=${uid}',
    chat: 'tgc://chat',
    questionlist: 'tgc://native?moduleName=questionlist',
    topicsquare: 'tgc://native?moduleName=topicsquare',
    topic: 'tgc://native?moduleName=topic',
    msg: 'tgc://native?moduleName=msg',
    commentlikemsg: 'tgc://native?moduleName=commentlikemsg',
    fansmsg: 'tgc://native?moduleName=fansmsg',
    answermsg: 'tgc://native?moduleName=answerMsg',
    officialmsg: 'tgc://native?moduleName=officialmsg',
    sysmsg: 'tgc://native?moduleName=sysMsg',
    inviteanswermsg: 'tgc://native?moduleName=inviteAnswerMsg',
    applyanswerer: 'tgc://native?moduleName=applyanswerer',
    answerGrowthCenter: 'tgc://native?moduleName=answer_growth_center',
    gamelist: 'tgc://native?moduleName=gamelist',
    groupcollection: 'tgc://native?moduleName=groupcollection',
    column: 'tgc://native?moduleName=column',
    columnDetail: 'tgc://native?moduleName=column_detail',
    medalWall: 'tgc://native?moduleName=medal_wall',
    pinch: 'tgc://native?moduleName=pinch',
    pinchPublish: 'tgc://native?moduleName=pinch_publish',
    pinchMine: 'tgc://native?moduleName=pinch_mine',
    pinchFaceSearch: 'tgc://native?moduleName=pinch_face_search',

    // eslint-disable-next-line no-template-curly-in-string
    qyg_index_share: 'hi-direct/pages/qyg_index.html?roleId=${roleId}&inviteCode=${inviteCode}&fromType=${fromType}',
    qyg_index: 'tgc://native?moduleName=qyg_index',
    qyg_bind: 'tgc://native?moduleName=qyg_bind',
    qyg_task: 'tgc://native?moduleName=qyg_task',
    qyg_anniversary: 'tgc://native?moduleName=qyg_anniversary',
    qyg_travel: 'tgc://native?moduleName=qyg_travel',
    qyg_bg: 'tgc://native?moduleName=qyg_bg',
    qyg_sweet_score: 'tgc://native?moduleName=qyg_sweet_score',
    qyg_all_photo: 'tgc://native?moduleName=qyg_all_photo',
    qyg_certification: 'tgc://native?moduleName=qyg_certification',
    qyg_map_album: 'tgc://native?moduleName=qyg_map_album',
    qyg_leaderboard: 'tgc://native?moduleName=qyg_leaderboard',
    qyg_gift_record: 'tgc://native?moduleName=qyg_gift_record',
    game_role_manage: 'tgc://native?moduleName=game_role_manage',
    protection_self_info: 'tgc://native?moduleName=protection_self_info',
    data_authorization: 'tgc://native?moduleName=data_authorization',
    protection: 'tgc://native?moduleName=protection',
    authorization_list: 'tgc://native?moduleName=authorization_list',
  },

  getWebUrl(name, params) {
    let { host } = this.web;
    let url = this.pageUrl[name] || '';
    // eslint-disable-next-line no-undef
    const branch = __BRANCH__ || '';
    if (branch && branch !== 'master' && branch !== 'dev_tgc') {
      url += `${url.indexOf('?') === -1 ? '?' : ''}&test_h5_branch=${branch}`;
    }
    const formatUrl = (host, url, params) => {
      if (params) {
        for (const i in params) {
          if (Object.prototype.hasOwnProperty.call(params, i)) {
            if (url.indexOf(`\${${i}}`) !== -1) {
              url = url.replace(`\${${i}}`, params[i]);
            } else {
              url += `&${i}=${params[i]}`;
            }
          }
        }
      }
      return host + url;
    };
    return new Promise((resolve) => {
      Vue.Native.callNativeWithPromise(
        'GameCommunityJsModule',
        'getNetEnvironment',
      ).then(async (environment) => {
        if (environment === this.netEnvironment.test) {
          host = this.web.testHost;
        }
        resolve(formatUrl(host, url, params));
      })
        .catch(() => {
          resolve(formatUrl(host, url, params));
        });
    });
  },

  getCGI() {
    return Vue.Jsbridge.getNetEnvironment(
      'GameCommunityJsModule',
      'getNetEnvironment',
    ).then(async (environment) => {
      if (environment === this.netEnvironment.test) {
        return this.cgi.testHost;
      } if (environment === this.netEnvironment.dev) {
        return this.cgi.devHost;
      }
      if (await this.isSubmit()) {
        return this.cgi.submitHost;
      }
      return this.cgi.host;
    });
  },

  getKKHost() {
    return Vue.Jsbridge.getNetEnvironment(
      'GameCommunityJsModule',
      'getNetEnvironment',
    ).then(async (environment) => {
      console.log('getKKHost environment', environment);
      if (environment === this.netEnvironment.test) {
        // return 'https://test-api.noknok.cn/';
        return 'https://test-h5api.knockknock.qq.com/';
      } if (environment === this.netEnvironment.dev) {
        return 'https://test-h5api.knockknock.qq.com/';
      }
      return 'https://h5api.knockknock.qq.com/';
    });
  },

  getAMSHost() {
    return Vue.Jsbridge.getNetEnvironment(
      'GameCommunityJsModule',
      'getNetEnvironment',
    ).then(async (environment) => {
      console.log('getAMSHost environment', environment);
      if (environment === this.netEnvironment.test) {
        return 'https://agw-t.xinyue.qq.com';
      } if (environment === this.netEnvironment.dev) {
        return 'https://agw-t.xinyue.qq.com';
      }
      return 'https://agw.xinyue.qq.com';
    });
  },

  isSubmit() { // promise
    return getApp().tools.getSwitchStatus();
  },

  getGroupDetailActionUrl(groupId) {
    if (groupId && groupId === '666666') {
      return `tgc://native?moduleName=blackHouse&groupId=${groupId}`;
    }
    return `tgc://native?moduleName=groupdetail&groupId=${groupId}`;
  },
};
